import { SidebarItemType } from '../sidebar-item'

export const isPathnameMatchUrl = (url: string, pathname: string): boolean => {
  // quick exact-match (ignore trailing slash) so items whose url contains the actual id
  // (e.g. `/.../journey-details/3`) will match the current pathname exactly
  const trimTrailing = (s: string) => (s.endsWith('/') && s.length > 1 ? s.slice(0, -1) : s)
  if (trimTrailing(url) === trimTrailing(pathname)) return true

  const doesUrlHaveANumber = url.search(/\/:\w+/g) !== -1
  const urlNoId = doesUrlHaveANumber ? url.slice(0, url.search(/\/:\w+/g)) : url

  const doesPathnameHaveANumber = pathname.search(/\/\d+/g) !== -1
  const pathnameNoId = doesPathnameHaveANumber
    ? pathname.slice(0, pathname.search(/\/\d+/g))
    : pathname

  return pathnameNoId === urlNoId
}

/**
 * Check if an item or one of its children is selected
 * - If the item has a url, it will be compared with the pathname
 * - If the item has children, it will recursively check if one of the children is selected
 * @param item
 * @param pathname
 * @returns
 */
export const isPathnameInSidebarParentUrls = (
  item: SidebarItemType,
  pathname: string
): boolean => {
  if (item.url && (isPathnameMatchUrl(item.url, pathname) || item.url === pathname)) return true
  if (item.activeUrls) return item.activeUrls.some((url) => isPathnameMatchUrl(url, pathname))
  return false
}

export const isSubItemSiblingOfActiveItem = (
  subItem: SidebarItemType,
  activeItem?: SidebarItemType
): boolean => {
  if (!activeItem) return false
  if (!activeItem.items) return false
  return activeItem.items.some((item) => item.itemKey === subItem.itemKey)
}

export const isItemAParentOfExpandedItem = (
  expandedItem: SidebarItemType,
  parentItem: SidebarItemType
): boolean => {
  if (parentItem.itemKey === expandedItem.itemKey) return true

  if (!parentItem.items) return false

  if (parentItem.items.some((subItem) => subItem.itemKey === expandedItem.itemKey)) {
    return true
  }

  return parentItem.items.some((subItem) => isItemAParentOfExpandedItem(expandedItem, subItem))
}
